export const PACKAGE_VERSION = '2.2.0'
